import { actions, selectors } from 'data'
import { TradeType } from 'data/Analytics/types'
import { mapTypeToTrackings } from 'data/Analytics/utils'
import { StateType } from 'data/types'
import { connect, ConnectedProps } from 'react-redux'

import OrderConfirmation from './template'

const mapStateToProps = (state: StateType) => ({
  counterCurrencySym: selectors.instrument.getCounterSymbol(state),
  fees: selectors.auth.getFees(state),
  marginDetails: selectors.order.getMarginOrderDetails(state),
  order: selectors.ticket.getValues(state),
  precision: selectors.instrument.getPrecision(state),
  screenWidth: selectors.app.getScreenWidth(state),
  symbol: selectors.instrument.getSymbol(state),
  ticker: selectors.ticker.getAll(state),
  type: selectors.ticket.getType(state),
  userFees: selectors.auth.getUserFees(state)
})

const mapDispatchToProps = (dispatch) => ({
  place: ({
    amount,
    collateralAmount,
    collateralCurrency,
    leverageRatio,
    margin,
    pair,
    price,
    side,
    stopPrice,
    tif,
    type
  }) => {
    dispatch(
      actions.analytics.trackEvent({
        key: 'Trade Submitted',
        properties: {
          collateral_amount: collateralAmount,
          collateral_currency: collateralCurrency,
          input_amount: parseFloat(amount ?? '0'),
          leverage_ratio: leverageRatio,
          limit_price: price,
          margin,
          pair,
          side: side.toUpperCase(),
          stop_price: stopPrice,
          tif,
          trade_type: mapTypeToTrackings(type) as TradeType
        }
      })
    )
    dispatch(actions.ticket.create())
    dispatch(actions.app.hideModal('ORDER_CONFIRMATION'))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type PropsType = ConnectedProps<typeof connector>

export default connector(OrderConfirmation)
